import { useMemo } from 'react'
import Decimal from 'decimal.js'
import { ClmmPool, CoinInfo, StructClass, SupplyPool } from '@kunalabs-io/kai'

import { PositionInfo } from '@/shared/kai/hooks/useUserPositions'

import { getProtocolDenyList, SwapType } from './useWithdrawDetails'
import { useRouter } from 'contexts/SwapRouterContext'
import { ReductionInfoSubmit } from '../../types'

interface Args {
  positionInfo: PositionInfo
  supplyPoolX?: SupplyPool<string, string>
  supplyPoolY?: SupplyPool<string, string>
  pool?: ClmmPool<StructClass, unknown, string, string>
  amountPercentage: number
  swapType: SwapType
  slippagePct: number
  overestimationPct: number
  afProtocols: Record<string, boolean>
  cetusProtocols: Record<string, boolean>
  convertRewards: boolean
  convertRewardsTo: CoinInfo<string>
}

export const useReductionInfo = ({
  positionInfo,
  supplyPoolX,
  supplyPoolY,
  pool,
  amountPercentage,
  slippagePct,
  overestimationPct,
  swapType,
  afProtocols,
  cetusProtocols,
  convertRewards,
  convertRewardsTo,
}: Args) => {
  const { routerLabel } = useRouter()

  const reductionInfoSubmit: ReductionInfoSubmit | undefined = useMemo(() => {
    if (!positionInfo || !pool || !supplyPoolX || !supplyPoolY) {
      return undefined
    }

    const factor = new Decimal(amountPercentage).div(100)

    const reduceAmounts = positionInfo.lastPosition.calcReduceAmountsHuman({
      factor,
      supplyPoolX,
      supplyPoolY,
      pool,
      timestampMs: Date.now(),
    })

    return {
      ...reduceAmounts,
      factor,
      slippage: slippagePct / 100,
      overestimation: overestimationPct / 100,
      swapMethod: swapType,
      convertRewardsTo: convertRewards ? convertRewardsTo : undefined,
      protocolDenyList: getProtocolDenyList(routerLabel, afProtocols, cetusProtocols),
    }
  }, [
    positionInfo,
    pool,
    supplyPoolX,
    supplyPoolY,
    amountPercentage,
    slippagePct,
    overestimationPct,
    swapType,
    convertRewards,
    convertRewardsTo,
    routerLabel,
    afProtocols,
    cetusProtocols,
  ])

  return reductionInfoSubmit
}
